class Feedback < ApplicationRecord
end
